export const GetStringIfNotEmpty = (value: string | null | undefined) => {
    return (value != null || value != undefined ? value : "");
}